<a class="contact-us" (click)="open(classic2, 'Notification', '')">
  <!-- <i class="fa fa-phone my-float"></i> -->
  <i class="ni ni-email-83 my-float" aria-hidden="true"></i>
</a>

<ng-template #classic2 let-c="close" let-d="dismiss">
  <div class="modal-content bg-gradient-danger">
    <div class="modal-header">
      <h6 class="modal-title ml-auto" id="modal-title-notification">
        Contact Us
      </h6>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="d('Cross click')"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="py-3 text-center">
        <form [formGroup]="popContact" (ngSubmit)="submit()">
          <div class="form-group mb-3" [ngClass]="{ focused: focus === true }">
            <div class="input-group input-group-alternative">
              <div class="input-group-prepend">
                <span class="input-group-text"
                  ><i class="ni ni-user-run"></i
                ></span>
              </div>
              <input
                formControlName="fname"
                id="fname"
                minlength="4"
                autocomplete="off"
                class="form-control"
                placeholder="Name"
                type="text"
                (focus)="focus = true"
                (blur)="focus = false"
              />
            </div>
            <div *ngIf="f.fname.touched && f.fname.invalid" class="error-alert">
              <div *ngIf="f.fname.errors.required">
                Full name is required.
              </div>
              <div *ngIf="f.fname.errors.minlength">
                Name must be at least 4 characters long.
              </div>
            </div>
          </div>
          <div class="form-group mb-3" [ngClass]="{ focused: focus === true }">
            <div class="input-group input-group-alternative">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="ni ni-email-83"></i>
                </span>
              </div>
              <input
                formControlName="email"
                id="email"
                type="email"
                minlength="8"
                maxlength="30"
                autocomplete="off"
                class="form-control"
                placeholder="Email"
                (focus)="focus = true"
                (blur)="focus = false"
              />
            </div>
            <div *ngIf="f.email.touched && f.email.invalid" class="error-alert">
              <div *ngIf="f.email.errors.required">
                Email is required.
              </div>
              <div *ngIf="f.email.errors.pattern">
                Please enter valid Email.
              </div>
              <div *ngIf="f.email.errors.minlength">
                Email must be at least 8 characters long.
              </div>
              <div *ngIf="f.email.errors.maxlength">
                Email can be max 30 characters long.
              </div>
            </div>
          </div>
          <div class="form-group" [ngClass]="{ focused: focus1 === true }">
            <div class="input-group input-group-alternative">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <!-- <i class="ni ni-lock-circle-open"></i> -->
                  <i class="fa fa-phone" aria-hidden="true"></i>
                </span>
              </div>
              <input
                formControlName="number"
                id="number"
                class="form-control"
                placeholder="Number"
                type="number"
                autocomplete="off"
                minlength="10"
                (focus)="focus1 = true"
                (blur)="focus1 = false"
              />
            </div>
            <div
              *ngIf="f.number.touched && f.number.invalid"
              class="error-alert"
            >
              <div *ngIf="f.number.errors.required">
                your Number should be at least 10 digit long!
              </div>
            </div>
          </div>
          <div class="form-group mb-3">
            <textarea
              class="form-control form-control-alternative"
              name="name"
              formControlName="msg"
              id="msg"
              minlength="10"
              rows="2"
              cols="80"
              placeholder="Type a message..."
            ></textarea>

            <div *ngIf="f.msg.touched && f.msg.invalid" class="error-alert">
              <div *ngIf="f.msg.errors.required">
                your message should be at least 10 characters long!
              </div>
            </div>
          </div>

          <div class="tc mb-4">
            <p>
              <input
                formControlName="check"
                id="check"
                type="checkbox"
                style="width: 17px; margin-left: -3.5px; height: 17px;"
              />
              <span
                style="
                  margin-left: 17px;
                  margin-bottom: 50px;
                  font-family: Georgia, 'Times New Roman', Times, serif;
                  margin-top: -15px;
                "
              >
                I agree to terms and conditions</span
              >
            </p>
            <div *ngIf="f.check.touched && f.check.invalid" class="error-alert">
              <div *ngIf="f.check.errors.required">
                Please select the term and condition it's required.
              </div>
            </div>
          </div>
          <!-- <div
                class="custom-control custom-control-alternative custom-checkbox"
              >
                <input
                  class="custom-control-input"
                  id=" customCheckLogin"
                  type="checkbox"
                />
                <label class="custom-control-label" for=" customCheckLogin">
                  <span>Remember me</span>
                </label>
              </div> -->
          <!-- <div class="text-center">
                <button type="button" class="btn btn-primary my-4">
                  Sign in
                </button>
              </div> -->
          <button
            type="button"
            class="btn btn-white"
            [disabled]="!popContact.valid"
          >
            Send
          </button>
          <button
            type="button"
            class="btn btn-link text-white ml-auto"
            data-dismiss="modal"
            (click)="c('Close click')"
          >
            Close
          </button>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<button class="bottom-to-top" *ngIf="isShow" (click)="gotoTop()">👆</button>
